'use strict';

var AppState = require('app_state');
var Consts = require('consts');
var Entry = require('components/sidebar/models/sidebar_entry');
var SidebarView = require('components/sidebar/views/sidebar_view');
var Sidemenu = require('utils/theme/sidemenu');
var i18n = require('utils/i18n');

var SidebarController = {
    view: undefined,
};

var getCategoryMenuSpec = function () {
    return [
        {
            permission: Consts.Permissions.Info,
            entry_id: 'ct-info',
            text: i18n.TR('Info'),
            icon: 'fa fa-info-circle',
            activePrefix: 'info',
            subs: [
                {
                    text: i18n.TR('Gerät'),
                    urlSuffix: '/info',
                    entry_id: 'ct-info-device',
                    active: 'info',
                },
                {
                    text: i18n.TR('Verwaltung'),
                    urlSuffix: '/info-management',
                    entry_id: 'ct-info-management',
                    active: 'info-management',
                },
            ],
        },
        {
            entry_id: 'ct-alarm',
            text: i18n.TR('Alarm'),
            icon: 'fa fa-bell-o',
            hideIfArchived: true,
            subs: [
                {
                    text: i18n.TR('Meldungen'),
                    urlSuffix: '/alarm-list',
                    entry_id: 'ct-alarm-list',
                    active: 'alarm-list',
                },
                {
                    text: i18n.TR('Konfiguration'),
                    urlSuffix: '/alarm-configuration',
                    entry_id: 'ct-alarm-configuration',
                    active: 'alarm-configuration',
                },
            ],
        },
        {
            text: i18n.TR('Zustand'),
            icon: 'fa fa-adjust',
            entry_id: 'ct-status',
            subs: [
                {
                    permission: Consts.Permissions.StateSchema,
                    text: i18n.TR('Anlagenschema'),
                    urlSuffix: '/status-schema',
                    entry_id: 'ct-status-schema',
                    active: 'status-schema',
                },
                {
                    permission: Consts.Permissions.StateData,
                    text: i18n.TR('Gesamtübersicht'),
                    urlSuffix: '/overview',
                    entry_id: 'ct-overview',
                    active: 'overview',
                    visibleCategories: ['Gateway', 'Gateway-RF'],
                },
                {
                    permission: Consts.Permissions.StateData,
                    text: i18n.TR('Daten'),
                    urlSuffix: '/status-data',
                    entry_id: 'ct-status-data',
                    active: 'status-data',
                },
                {
                    permission: Consts.Permissions.EventLog,
                    text: i18n.TR('Ereignisse'),
                    urlSuffix: '/status-log',
                    entry_id: 'ct-status-log',
                    active: 'status-log',
                },
            ],
        },
        {
            permission: Consts.Permissions.MeterReadings,
            text: i18n.TR('Zählerstand'),
            urlSuffix: '/meter',
            icon: 'fa fa-tachometer',
            entry_id: 'ct-meter',
            active: 'meter',
        },
        {
            text: i18n.TR('Bedienung'),
            icon: 'fa fa-sliders',
            entry_id: 'ct-handling',
            subs: [
                {
                    permission: Consts.Permissions.HandlingCircuit1,
                    text: i18n.TR('Heizkreis 1'),
                    urlSuffix: '/control-1',
                    entry_id: 'ct-control-1',
                    active: 'control-1',
                },
                {
                    permission: Consts.Permissions.HandlingCircuit2,
                    text: i18n.TR('Heizkreis 2'),
                    urlSuffix: '/control-2',
                    entry_id: 'ct-control-2',
                    active: 'control-2',
                },
                {
                    permission: Consts.Permissions.HandlingCircuit3,
                    text: i18n.TR('Heizkreis 3'),
                    urlSuffix: '/control-3',
                    entry_id: 'ct-control-3',
                    active: 'control-3',
                },
                {
                    permission: Consts.Permissions.HandlingWater,
                    text: i18n.TR('Trinkwasser'),
                    urlSuffix: '/control-water',
                    entry_id: 'ct-water',
                    active: 'control-water',
                },
                {
                    permission: Consts.Permissions.HandlingCircuit11,
                    text: i18n.TR('Heizkreis 11'),
                    urlSuffix: '/control-11',
                    entry_id: 'ct-control-11',
                    active: 'control-11',
                },
                {
                    permission: Consts.Permissions.HandlingCircuit12,
                    text: i18n.TR('Heizkreis 12'),
                    urlSuffix: '/control-12',
                    entry_id: 'ct-control-12',
                    active: 'control-12',
                },
                {
                    permission: Consts.Permissions.HandlingCircuit13,
                    text: i18n.TR('Heizkreis 13'),
                    urlSuffix: '/control-13',
                    entry_id: 'ct-control-13',
                    active: 'control-13',
                },
                {
                    permission: Consts.Permissions.HandlingParameter,
                    text: i18n.TR('Parametrierung'),
                    urlSuffix: '/control-parameter',
                    entry_id: 'ct-parameter',
                    active: 'control-parameter',
                },
                /*{
					permission: Consts.Permissions.HandlingRemote,
					text:       i18n.TR('Fernbedienung'),
					urlSuffix:  '/control-remote',
					entry_id:   'ct-remote',
					active:     'control-remote'
				},*/
            ],
        },
        {
            permission: Consts.Permissions.Analysis,
            text: i18n.TR('Analyse'),
            urlSuffix: '/analyze',
            icon: 'fa fa-bar-chart-o',
            entry_id: 'ct-analyze',
            active: 'analyze',
        },
        {
            text: i18n.TR('Verwaltung'),
            icon: 'fa fa-wrench',
            entry_id: 'ct-administration',
            subs: [
                {
                    visibleWhenCanConnectTo: true,
                    permission: Consts.Permissions.AdminDevices,
                    text: i18n.TR('Geräte'),
                    urlSuffix: '/admin-devices',
                    entry_id: 'ct-admin-devices',
                    active: 'admin-devices',
                },
                {
                    permission: Consts.Permissions.AdminUser,
                    text: i18n.TR('Nutzer'),
                    urlSuffix: '/admin-user',
                    entry_id: 'ct-admin-user',
                    active: 'admin-user',
                },
                {
                    permission: Consts.Permissions.AdminConfig,
                    text: i18n.TR('Konfiguration'),
                    urlSuffix: '/admin-configuration',
                    entry_id: 'ct-admin-config',
                    active: 'admin-configuration',
                    needDataAccess: true,
                },
            ],
        },
    ];
};

SidebarController.showDefaultSidebar = function (active) {
    var availableDevicesByCategory = AppState.getAvailableCategoryCount();
    if (!_.keys(availableDevicesByCategory).length) {
        // no devices available -> show empty sidebar and minimize
        Sidemenu.openLeftBar();
        return;
    }

    var sidebarConfig = [];

    if (AppState.dashboardAvailable()) {
        sidebarConfig.push({
            text: i18n.TR('Dashboard'),
            icon: 'fa fa-th',
            active: active == 'dashboard',
            entry_id: 'ct-dashboard',
            url: '#dashboard',
        });
    }
    sidebarConfig.push({
        text: i18n.TR('Alarm'),
        icon: 'fa fa-bell-o',
        active: active !== undefined && active.startsWith('alarm'),
        entry_id: 'ct-alarm',
        subs: [
            {
                text: i18n.TR('Meldungen'),
                url: '#alarm-list',
                active: active == 'alarm-list',
            },
            {
                text: i18n.TR('Konfiguration'),
                url: '#alarm-configuration',
                entry_id: 'ct-alarm-config',
                active: active == 'alarm-configuration',
            },
        ],
    });

    sidebarConfig.push({ text: i18n.TR('Geräte') });

    var categoryList = [];
    _.each(Consts.CategoryData, function (data, category) {
        if (availableDevicesByCategory[Consts.Category[category]] > 0) {
            categoryList.push({
                pos: data.menuPos,
                text: data.menuText,
                url: data.url,
                icon: data.icon,
                entry_id: data.sidebar_entry || data.category,
                active: active == data.category,
            });
        }
    });

    categoryList = _.sortBy(categoryList, 'pos');
    sidebarConfig = _.flatten([sidebarConfig, categoryList]);

    sidebarConfig.push({ text: i18n.TR('Werkzeuge') });
    sidebarConfig.push({
        text: i18n.TR('Karte'),
        url: '#map',
        icon: 'fa fa-map',
        entry_id: 'ct-map',
        active: active == 'map',
    });
    sidebarConfig.push({
        text: i18n.TR('Statistik'),
        url: '#stats',
        icon: 'fa fa-bar-chart-o',
        entry_id: 'ct-stats',
        active: active == 'stats',
    });
    sidebarConfig.push({
        text: i18n.TR('Smart Detection'),
        url: '#ranking',
        icon: 'icon-smart-detection',
        entry_id: 'ct-ranking',
        active: active == 'ranking',
        isHidden: !AppState.isDeviceRanking(),
    });
    sidebarConfig.push({
        text: i18n.TR('Suche'),
        url: '#search',
        icon: 'fa fa-search',
        entry_id: 'ct-search',
        active: active == 'search',
    });
    this.showSidebar(sidebarConfig);
};

var allowed = function (permissions) {
    for (var i = 1; i < arguments.length; ++i) {
        if (permissions.get(arguments[i]) !== undefined) {
            return true;
        }
    }
    return false;
};

SidebarController.showCategorySidebar = function (id, permissions, active, userDefNames, category) {
    userDefNames = userDefNames || {};
    var menuItems = [];
    var urlBase = Consts.DeviceCategory[category].url + '/' + id;

    var isItemVisible = function (item, id) {
        // explicit visibility
        var isVisible = true;
        if (item.visible) {
            isVisible = false;
            _.each(item.visible, function (cat) {
                isVisible = isVisible || cat == category;
            });
        }

        // visible when can be connected to
        if (isVisible && item.visibleWhenCanConnectTo) {
            isVisible = false;
            _.each(Consts.CategoryData, function (c) {
                if (c.connectsTo && c.connectsTo.indexOf(category) >= 0) {
                    isVisible = true;
                }
            });
        }

        if (item.visibleCategories) {
            isVisible = isVisible && item.visibleCategories.includes(category);
        }

        // has permission
        isVisible = isVisible && (!item.permission || allowed(permissions, item.permission));
        if (!isVisible) {
            return false;
        }

        // has access to required fields
        if (item.fields !== undefined) {
            _.each(item.fields, function (f) {
                isVisible = isVisible && AppState.availableColumnData(f);
            });
        }

        if (item.subs && item.subs.length > 0) {
            isVisible = false;
            _.each(item.subs, function (subitem) {
                isVisible = isVisible || isItemVisible(subitem, id);
            });
        }

        if (item.needDataAccess && AppState.getDeviceInfo(id).station < 1) {
            return false;
        }

        // device is archived?
        if (item.hideIfArchived && AppState.getDeviceInfo(id).status === Consts.DeviceStatus.Archived) {
            isVisible = false;
        }

        return isVisible;
    };

    var createItem = function (item) {
        var newActiveValue = false;
        if (item.active) newActiveValue = active == item.active;
        if (item.subs && item.subs.length > 0) {
            _.each(item.subs, function (subitem) {
                newActiveValue = newActiveValue || (subitem.active && subitem.active == active);
            });
        }

        var newItem = {
            text: userDefNames[item.active] || item.text,
            icon: item.icon,
            active: newActiveValue,
            subs: item.subs && item.subs.length > 0 ? [] : undefined,
            url: item.url || (item.urlSuffix ? urlBase + item.urlSuffix : undefined),
            entry_id: item.entry_id,
        };

        // subitems
        _.each(item.subs, function (subitem) {
            if (isItemVisible(subitem, id)) {
                newItem.subs.push(createItem(subitem));
            }
        });

        return newItem;
    };

    _.each(
        getCategoryMenuSpec(),
        function (item) {
            if (isItemVisible(item, this.id)) {
                menuItems.push(createItem(item));
            }
        },
        { id: id }
    );

    this.showSidebar(menuItems);
};

var allowedCompany = function (required) {
    var permissions = AppState.user.attributes.permissions || [];
    for (var i = 0; i < permissions.length; ++i) {
        if (permissions[i] == required) {
            return true;
        }
    }
    return false;
};

SidebarController.showProfileSidebar = function (active, featureFlags) {
    var isDeviceAdmin =
        allowedCompany(Consts.PermissionsCompany.AddDevices) ||
        allowedCompany(Consts.PermissionsCompany.RemoveDevices) ||
        allowedCompany(Consts.PermissionsCompany.ViewDevices);

    var urlBase = '#profile/';

    var entries = [
        {
            text: i18n.TR('Mein Konto'),
            url: urlBase + 'settings',
            icon: 'fa fa-wrench',
            entry_id: 'ct-settings',
            active: active == 'settings',
        },
    ];

    if (allowedCompany(Consts.PermissionsCompany.ViewBilling)) {
        entries.push({
            text: i18n.TR('Rechnungen'),
            url: urlBase + 'billing',
            icon: 'fa fa-dollar',
            entry_id: 'ct-billing',
            active: active == 'billing',
        });
    }

    if (isDeviceAdmin) {
        var reportSubEntries = _.compact([
            featureFlags[Consts.Features.CommunicationReport] === true
                ? {
                      text: i18n.TR('Kommunikation'),
                      icon: 'fa fa-file-text-o',
                      url: urlBase + 'report-communication',
                      entry_id: 'ct-report-communication',
                      active: active == 'report-communication',
                  }
                : undefined,
            featureFlags[Consts.Features.DeviceReporting] !== null
                ? {
                      text: i18n.TR('Geräte'),
                      icon: 'fa fa-file-text-o',
                      url: urlBase + 'report-devices',
                      entry_id: 'ct-report-devices',
                      active: active == 'report-devices',
                  }
                : undefined,
        ]);

        if (reportSubEntries.length != 0) {
            entries.push({ text: i18n.TR('Berichte') });
            _.each(reportSubEntries, function (e) {
                entries.push(e);
            });
        }
    }

    if (allowedCompany(Consts.PermissionsCompany.ManageUsers)) {
        entries.push({ text: i18n.TR('Zugriffsrechte') });
        entries.push({
            text: i18n.TR('Administratoren'),
            icon: 'md md-group',
            url: urlBase + 'access-admins',
            entry_id: 'ct-access-admins',
            active: active == 'access-admins',
        });
        entries.push({
            text: i18n.TR('Benutzergruppen'),
            icon: 'fa fa-group',
            url: urlBase + 'access-user-groups',
            entry_id: 'ct-access-user-groups',
            active: active == 'access-user-groups',
        });
        entries.push({
            text: i18n.TR('Gerätegruppen'),
            icon: 'fa fa-object-group',
            url: urlBase + 'access-device-groups',
            entry_id: 'ct-access-device-groups',
            active: active == 'access-device-groups',
        });

        entries.push({ text: i18n.TR('Anpassungen') });
        entries.push({
            text: i18n.TR('Postfächer'),
            icon: 'md md-email',
            url: urlBase + 'access-mailboxes',
            entry_id: 'ct-email',
            active: active == 'access-mailboxes',
        });
        if (AppState.canLabelPool()) {
            entries.push({
                text: i18n.TR('Label'),
                icon: 'fa fa-tag',
                url: urlBase + 'label-pool',
                entry_id: 'ct-label-pool',
                active: active == 'label-pool',
            });
        }
    }

    entries.push({ text: i18n.TR('Schnittstellen') });
    entries.push({
        text: i18n.TR('API Spezifikation'),
        url: urlBase + 'api',
        icon: 'fa fa-connectdevelop',
        entry_id: 'ct-api',
        active: active == 'api',
    });

    if (allowedCompany(Consts.PermissionsCompany.ManageUsers)) {
        entries.push({
            text: i18n.TR('API Token'),
            icon: 'fa fa-connectdevelop',
            url: urlBase + 'access-api-config',
            entry_id: 'ct-access-api-config',
            active: active == 'access-api-config',
        });
    }

    var features = AppState.user.get('features');
    if (isDeviceAdmin && features.webhook_event_type && features.webhook_event_type.length !== 0) {
        entries.push({
            text: i18n.TR('Webhooks'),
            url: urlBase + 'webhooks',
            icon: 'fa fa-file-code-o',
            entry_id: 'ct-webhooks',
            active: active === 'webhooks',
        });
    }

    this.showSidebar(entries);
};

SidebarController.showSidebar = function (entryParams) {
    var collection = new Entry.Collection(entryParams);

    if (this.view === undefined) {
        this.view = new SidebarView({
            collection: collection,
        });
        AppState.layout.showChildView('sidebar', this.view);
    } else {
        this.view.collection = collection;
        this.view.render();
    }
};

SidebarController.resetSidebar = function () {
    this.view = undefined;
};

module.exports = SidebarController;
